import styled from 'styled-components';

const StyledModalCloseButton = styled.button`
  position: absolute;
  right: .5rem;
  top: 1rem;
  z-index: 1;
`;

export { StyledModalCloseButton };
